import { cn } from "@/lib/utils";
import { HTMLAttributes } from "react";

type Props = {
  position?: "bottom" | "right";
} & HTMLAttributes<HTMLSpanElement>;
const Popover = ({ position = "bottom", hidden }: Props) => {
  return (
    <span
      hidden={hidden}
      className={cn(
        "absolute mt-0.5 max-w-fit min-w-[4.375rem] text-center rounded-sm bg-blue-600 px-1.5 py-0.5 text-xs text-white whitespace-nowrap",
        position === "bottom" && "top-full -translate-x-1/2 left-1/2",
        position === "right" && "top-1/2 -translate-y-1/2 ml-4",
      )}
    >
      최근 로그인
      <div
        className={cn(
          "absolute size-2 rotate-45 bg-blue-600",
          position === "bottom" && "-top-1 left-1/2 -translate-x-1/2",
          position === "right" && "-left-1 top-1/2 -translate-y-1/2",
        )}
      ></div>
    </span>
  );
};

export default Popover;
